(async () => {
  const config = window.__STATSIG_CONFIG__;

  if (!config) { return; }

  const [{ StatsigClient }, { forceStartRecording, runStatsigTriggeredSessionReplay }] = await Promise.all([
    import('@statsig/js-client'),
    import('@statsig/session-replay'),
  ]);

  const client = new StatsigClient(
    config.clientKey,
    config.user,
    {
      environment: { tier: config.tier },
      networkConfig: {
        initializeUrl: 'https://featureassets.org/v1/initialize',
        logEventUrl: 'https://prodregistryv2.org/v1/rgstr',
      },
    }
  );

  runStatsigTriggeredSessionReplay(client, { autoStartRecording: false });

  try {
    await client.initializeAsync();
  } catch (_err) {
    return;
  }

  forceStartRecording(config.clientKey);
})();
